import MainLayout from '../components/layout/MainLayout'
import { useLanguageContext } from '../context/Language'

export default function OPerator() {
	const { t } = useLanguageContext()
	return (
		<MainLayout>
			<div className="flex flex-wrap justify-between gap-3 items-center mb-6">
				<div className="flex flex-col gap-1">
					<p className="text-secondary text-3xl font-bold leading-tight tracking-tight">{t('DASHBOARD_OVERVIEW')}</p>
					<p className="text-secondary/60 text-base font-normal leading-normal">{t('AI_CONVERSATION_REVIEW')}</p>
				</div>
				<button className="flex cursor-pointer items-center justify-center overflow-hidden rounded-xl h-12 bg-primary text-white gap-2 text-sm font-bold leading-normal tracking-wide min-w-0 px-5 shadow-soft-button hover:bg-primary/90 transition-all">
					<span className="material-symbols-outlined fill text-xl">fact_check</span>
					<span className="truncate">{t('CLIENT')}</span>
				</button>
			</div>
			<div className="bg-white rounded-xl shadow-soft border border-border-light overflow-hidden">
				<div className="overflow-x-auto">
					<table className="w-full text-left">
						<thead className="bg-secondary/5">
							<tr>
								<th className="p-4 text-xs font-semibold text-secondary/60 uppercase tracking-wider w-1/4">{t('USERS')}</th>
								<th className="p-4 text-xs font-semibold text-secondary/60 uppercase tracking-wider w-1/4">{t('MESSAGE_PREVIEW')}</th>
								<th className="p-4 text-xs font-semibold text-secondary/60 uppercase tracking-wider w-1/4">{t('AI_RESPONSE')}</th>
								<th className="p-4 text-xs font-semibold text-secondary/60 uppercase tracking-wider">{t('STATUS')}</th>
								<th className="p-4 text-xs font-semibold text-secondary/60 uppercase tracking-wider text-center">{t('CONFIDENCE')}</th>
								<th className="p-4 text-xs font-semibold text-secondary/60 uppercase tracking-wider">{t('DATE')}</th>
								<th className="p-4 text-xs font-semibold text-secondary/60 uppercase tracking-wider">{t('ACTIONS')}</th>
							</tr>
						</thead>
						<tbody className="divide-y divide-border-light">
							<tr className="hover:bg-accent/20 transition-colors">
								<td className="p-5 align-top">
									<div className="flex items-center gap-3">
										<img className="size-10 rounded-full" alt="User avatar for Jane Doe" src="https://lh3.googleusercontent.com/aida-public/AB6AXuD-u78B77H_pIme5RlKh8NthyPvcq7jZImMyJeg8_xLwBjN2qpCD959MbzKqltQkk7zRyPrDC2k9KGjxUkh4oSkILbHBmsIxd9m2Vgt7u-OiNVNfVuSgeuzg6Z5aVEEoxilgLDNim1xzWovgvKxQgYIeVjiO8dmftv0fk82Bqp6BYA5dccWV6kP7RuL8pIcxfQYIFYcehX2jODStxPS7LiONHrNNuPx7dqoZHwPaPpCDPos6Y8SQK08-MICkN7rrs39-ZRADxICqHQu" />
										<div className="flex flex-col">
											<p className="font-semibold text-secondary">Jane Doe</p>
											<p className="text-sm text-secondary/60">@janedoe_designs</p>
										</div>
									</div>
								</td>
								<td className="p-5 text-sm text-secondary/80 align-top">"Hey! I love your new product. Can I get a discount?"</td>
								<td className="p-5 text-sm text-secondary/80 align-top">"Thanks, Jane! We're so glad you like it. We've just sent you a DM with a special 15% off code."</td>
								<td className="p-5 align-top">
									<span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-success/10 text-success">Handled</span>
								</td>
								<td className="p-5 text-sm font-medium text-secondary/80 text-center align-top">98%</td>
								<td className="p-5 text-sm text-secondary/60 align-top">Mar 12, 2024</td>
								<td className="p-5 align-top">
									<div className="flex items-center gap-2 text-secondary/60">
										<button className="p-1.5 rounded-md hover:bg-secondary/10 hover:text-secondary">
											<span className="material-symbols-outlined text-xl">edit</span>
										</button>
										<button className="p-1.5 rounded-md hover:bg-secondary/10 hover:text-secondary">
											<span className="material-symbols-outlined text-xl">visibility</span>
										</button>
									</div>
								</td>
							</tr>
							<tr className="hover:bg-accent/20 transition-colors">
								<td className="p-5 align-top">
									<div className="flex items-center gap-3">
										<img className="size-10 rounded-full" alt="User avatar for John Smith" src="https://lh3.googleusercontent.com/aida-public/AB6AXuD00BPc0Jcb8_yEAwCS1SrMfzH4SQ-UMcQkjjKA_IQMK9PSbBpOJx72yFt8I52JGbJG3u8vYpnT8w9EK2xeXWVYanMj4GWFEf63E7x-d83FAWoYYgE3Ind_Z9ebsQyhdqdN4qW-pMf-rN-tTAGTkujxurjIVXph1RRePQi7OutSsVa_-K_05GnfZQV5-_0_aIMiBgGfMQ1cUNOVvq1wIbLjqE9a7-ILnF-5_7ZVx02t_CQPJVu8N2TLkE6wYucUfZjpcc3KgK9-aQT9" />
										<div className="flex flex-col">
											<p className="font-semibold text-secondary">John Smith</p>
											<p className="text-sm text-secondary/60">@johnsmith</p>
										</div>
									</div>
								</td>
								<td className="p-5 text-sm text-secondary/80 align-top">"My order #12345 hasn't arrived yet. What's the status?"</td>
								<td className="p-5 text-sm text-secondary/80 align-top">"Hi John, I've checked order #12345 and it seems there's a delay. I've escalated this to our support team for you."</td>
								<td className="p-5 align-top">
									<span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-warning/10 text-warning">Needs Review</span>
								</td>
								<td className="p-5 text-sm font-medium text-secondary/80 text-center align-top">76%</td>
								<td className="p-5 text-sm text-secondary/60 align-top">Mar 11, 2024</td>
								<td className="p-5 align-top">
									<div className="flex items-center gap-2 text-secondary/60">
										<button className="p-1.5 rounded-md hover:bg-secondary/10 hover:text-secondary">
											<span className="material-symbols-outlined text-xl">edit</span>
										</button>
										<button className="p-1.5 rounded-md hover:bg-secondary/10 hover:text-secondary">
											<span className="material-symbols-outlined text-xl">visibility</span>
										</button>
									</div>
								</td>
							</tr>
							<tr className="hover:bg-accent/20 transition-colors">
								<td className="p-5 align-top">
									<div className="flex items-center gap-3">
										<img className="size-10 rounded-full" alt="User avatar for Emily White" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAJ6Yd9HLT6lyPo0PeHRhCHcOp8CLf541PKIqrUclkEOcASJ6VZ7bFijV-tQEvpLJyg03ts5z3kFobLEhRVWP07HuvwwwGj6YLf6nsVdg8ywWTzq9ODU-01NoNLJVsev84mTNsy9peSfHKQmWt8uWT0IHIYmpIXdN7oOWIJbp6AKvo8GDKk8Rhx8Gv6PX9K_OzCAlP6yMrv60SRdes-Gz1AlLidewLKavcdJzUfeONfuzWUwokRtRPktcUNBD2_VPxhukDP-g8jQcCV" />
										<div className="flex flex-col">
											<p className="font-semibold text-secondary">Emily White</p>
											<p className="text-sm text-secondary/60">@emilyw</p>
										</div>
									</div>
								</td>
								<td className="p-5 text-sm text-secondary/80 align-top">"This is amazing! 🔥"</td>
								<td className="p-5 text-sm text-secondary/80 align-top">"Thank you so much, Emily! 🙌"</td>
								<td className="p-5 align-top">
									<span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-success/10 text-success">Handled</span>
								</td>
								<td className="p-5 text-sm font-medium text-secondary/80 text-center align-top">99%</td>
								<td className="p-5 text-sm text-secondary/60 align-top">Mar 10, 2024</td>
								<td className="p-5 align-top">
									<div className="flex items-center gap-2 text-secondary/60">
										<button className="p-1.5 rounded-md hover:bg-secondary/10 hover:text-secondary">
											<span className="material-symbols-outlined text-xl">edit</span>
										</button>
										<button className="p-1.5 rounded-md hover:bg-secondary/10 hover:text-secondary">
											<span className="material-symbols-outlined text-xl">visibility</span>
										</button>
									</div>
								</td>
							</tr>
							<tr className="hover:bg-accent/20 transition-colors">
								<td className="p-5 align-top">
									<div className="flex items-center gap-3">
										<img className="size-10 rounded-full" alt="User avatar for Sarah Brown" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAVKmR-ESNz8gej2V6dW02IZ7lVCsHTLwhzU2qaZcviYUMyvvXoAh_Jjkf_zN1wVvtdOgsblPK20_x32Jyz4kTCB-HBgKixKklGr6zbrRGTyInlTuTE_YzG3xnZ3HxJe6WeZrau6gpLqRygnWNk-c-ZZ5EYy0SEJ3MfDijrqeXOqWREXW4APw4VSegp2Kx1_dpELpwRIs7wePzmCJssxHc3QYZLAvh5kCVQmt3LBH7fFSxYGltsoLBO6aJYd65VzRNRT2OV2YY50sKx" />
										<div className="flex flex-col">
											<p className="font-semibold text-secondary">Sarah Brown</p>
											<p className="text-sm text-secondary/60">@sarahb_creative</p>
										</div>
									</div>
								</td>
								<td className="p-5 text-sm text-secondary/80 align-top">"When is the new feature launching?"</td>
								<td className="p-5 text-sm text-secondary/80 align-top">"Soon! Keep an eye on our page for the official announcement next week."</td>
								<td className="p-5 align-top">
									<span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-success/10 text-success">Handled</span>
								</td>
								<td className="p-5 text-sm font-medium text-secondary/80 text-center align-top">95%</td>
								<td className="p-5 text-sm text-secondary/60 align-top">Mar 9, 2024</td>
								<td className="p-5 align-top">
									<div className="flex items-center gap-2 text-secondary/60">
										<button className="p-1.5 rounded-md hover:bg-secondary/10 hover:text-secondary">
											<span className="material-symbols-outlined text-xl">edit</span>
										</button>
										<button className="p-1.5 rounded-md hover:bg-secondary/10 hover:text-secondary">
											<span className="material-symbols-outlined text-xl">visibility</span>
										</button>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</MainLayout>
	)
}